// extracted by mini-css-extract-plugin
module.exports = {"default":"loading_default__gbZhd","full-screen":"loading_full-screen__4I3MA"};